module.exports = __webpack_public_path__ + "img/3.fc0b55f6.png";